import { SettingsServiceFunctionsDto } from '@sr/dto';
import { FormikErrors } from 'formik';
import { FormTools } from 'utils/form-tools';

export type FormData = {
  createPayOrdersFromPurchases: boolean;
};

export const formTools: FormTools<SettingsServiceFunctionsDto & { id: number }, SettingsServiceFunctionsDto, SettingsServiceFunctionsDto, FormData> = {
  fromDto: (dto: SettingsServiceFunctionsDto): FormData => {
    return { createPayOrdersFromPurchases: dto.createPayOrdersFromPurchases };
  },
  toCreateDto: (formData: FormData): SettingsServiceFunctionsDto => {
    return {
      createPayOrdersFromPurchases: formData.createPayOrdersFromPurchases,
    };
  },
  toUpdateDto: () => {
    throw new Error('Not implemented.');
  },
  validate: () => {
    const errors: FormikErrors<FormData> = {};
    return errors;
  },
  emptyValues: () => ({ createPayOrdersFromPurchases: true, id: 1 }),
};
